import { render, staticRenderFns } from "./receiveShare.vue?vue&type=template&id=67f07c2b&scoped=true&"
import script from "./receiveShare.vue?vue&type=script&lang=js&"
export * from "./receiveShare.vue?vue&type=script&lang=js&"
import style0 from "./receiveShare.vue?vue&type=style&index=0&id=67f07c2b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f07c2b",
  null
  
)

export default component.exports